import {
    Button,
    createStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles,
} from "@material-ui/core";
import React, {useState} from "react";
import AuthService from "../../service/AuthService";
import CustomTextField from "../ui/CustomTextField";

const useStyles = makeStyles((theme) =>
    createStyles({
        name: {
            marginBottom: theme.spacing(2),
        },
    })
);

const CreateContactsListDialog = (args) => {
    const {
        open,
        setOpen,
        listCreated,
    } = args;
    const classes = useStyles();

    const [item, setItem] = useState({
        name: '',
        description: '',
    });

    const handleSubmit = function (event) {
        event.preventDefault();

        fetch("/api/contactsLists", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + AuthService.getUserInfo().token
            },
            body: JSON.stringify(item),
        }).then(() => {
            setOpen(false);
            listCreated(true);
        }).catch((error) => {
            console.error("Could not create a new list.");
            console.error(error);
        });
    }

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">Neue Liste erstellen</DialogTitle>
            <DialogContent>
                <CustomTextField
                    className={classes.name}
                    autoFocus
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(event) => {
                        item.name = event.currentTarget.value
                        setItem(item);
                    }}
                />
                <CustomTextField
                    id="description"
                    label="Beschreibung"
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    onChange={(event) => {
                        item.description = event.currentTarget.value
                        setItem(item);
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    setOpen(false);
                }}>
                    Abbrechen
                </Button>
                <Button onClick={handleSubmit} color="primary">
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateContactsListDialog;
